(() => {
  if (customElements.get('parana-product')) return;
  class ParanaProductPage extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.index = 0;
      this.media = [...this.querySelectorAll('[data-pp-media]')];
      try { this.messages = JSON.parse(this.querySelector('[data-pp-i18n]').textContent); } catch { this.messages = {}; }
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-pp-thumb]');
        if (thumb) this.showMedia(Number(thumb.dataset.ppThumb));
        if (event.target.closest('[data-pp-prev]')) this.showMedia((this.index - 1 + this.media.length) % this.media.length);
        if (event.target.closest('[data-pp-next]')) this.showMedia((this.index + 1) % this.media.length);
        if (event.target.closest('[data-pp-zoom]')) {
          const source = this.media[this.index]?.querySelector('img'), dialog = this.querySelector('.pp-lightbox');
          if (source && dialog) { const image = dialog.querySelector('img'); image.src = source.src; image.alt = source.alt; dialog.showModal(); }
        }
        if (event.target.closest('[data-pp-close]')) this.querySelector('.pp-lightbox').close();
        if (event.target.matches('.pp-lightbox')) { const rect=event.target.getBoundingClientRect(); if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)event.target.close(); }
        if (event.target.closest('[data-pp-share]')) this.share();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.pp-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.showMedia((this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.media.length) % this.media.length);
        this.querySelector(`[data-pp-thumb="${this.index}"]`)?.focus();
      }, { signal });
      this.mountPurchase();
      this.loadRelated();
    }
    disconnectedCallback() { this.controller?.abort(); this.purchaseRequest?.abort(); this.translationObserver?.disconnect(); this.started = false; }
    text(key, fallback) { return this.messages[key] || fallback; }
    showMedia(index) {
      if (!this.media[index]) return;
      this.media[this.index]?.querySelectorAll('video').forEach(video => video.pause());
      this.index = index;
      this.media.forEach((media, i) => { media.hidden = i !== index; });
      this.querySelectorAll('[data-pp-thumb]').forEach((thumb,i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const counter = this.querySelector('[data-pp-counter]'); if (counter) counter.textContent = `${index + 1} / ${this.media.length}`;
    }
    async mountPurchase() {
      const mount = this.querySelector('[data-pp-purchase]');
      if (!window.ParanaProduct?.mount) { mount.textContent = this.text('load_error','Unable to load product options. Please reload this page.'); return; }
      const result = await window.ParanaProduct.mount(this.dataset.url, mount);
      if (!this.isConnected || !result) return;
      this.purchaseRequest = result.request;
      const { product, form, unit } = result;
      form.querySelectorAll('input[type=number]').forEach(input => {
        const group = document.createElement('div'); group.className = 'pp-quantity'; input.before(group);
        const decrement = document.createElement('button'), increment = document.createElement('button');
        [[decrement,'−',-1],[increment,'+',1]].forEach(([button,label,direction]) => { button.type='button'; button.textContent=label; button.setAttribute('aria-label',`${this.text(unit.label,unit.label || 'Units')} ${label}`); button.addEventListener('click',() => { const next=Number(input.value)+direction; input.value=String(Math.max(Number(input.min),Math.min(Number(input.max),next))); input.dispatchEvent(new Event('input',{bubbles:true})); }); });
        group.append(decrement,input,increment);
      });
      if (product.variants.length === 1 && !/power|sphere|sph|grau|prescription/i.test(product.options.map(option => option.name || option).join(' ')) && !unit.singleLens) {
        const fieldset = form.querySelector('fieldset');
        fieldset.querySelector('legend').hidden = true;
        fieldset.querySelector('label').hidden = true;
        fieldset.querySelector('.pr-variant-picker').hidden = true;
        fieldset.classList.add('pp-simple-quantity');
        const note = form.querySelector('.pr-prescription-note');
        const packaging = unit.label === 'Pairs' ? 'simple_pair' : unit.label === 'Boxes' ? 'simple_box' : 'simple_units';
        const fallback = packaging === 'simple_pair' ? '{count} lenses per pair. Quantity counts complete pairs.' : packaging === 'simple_box' ? '{count} lenses per box. Quantity counts complete boxes.' : 'Quantity counts whole selling units.';
        if (note) note.textContent = this.text(packaging, fallback).replace('{count}', unit.lensesPerUnit);
      }
      const updateVariant = () => {
        const select = form.querySelector('select');
        const variant = product.variants.find(item => String(item.id) === select?.value);
        if (!variant) return;
        const price = this.querySelector('[data-pp-price]');
        const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents/100);
        price.replaceChildren();
        if (variant.compare_at_price > variant.price) { const compare = document.createElement('s'); compare.textContent = format(variant.compare_at_price); price.append(compare); }
        price.append(document.createTextNode(format(variant.price)));
        if (unit.singleLens) { const suffix = document.createElement('small'); suffix.textContent = this.text('per_lens','per lens'); price.append(suffix); }
        const availability = this.querySelector('.pp-availability'); if (availability) availability.textContent = variant.available ? this.text('available','Available') : this.text('sold_out','Sold out');
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({},'',url);
        if (variant.featured_image?.src) { const position = this.media.findIndex(media => media.querySelector('img')?.src.split('?')[0] === variant.featured_image.src.split('?')[0]); if(position >= 0)this.showMedia(position); }
      };
      form.addEventListener('change', updateVariant, { signal: this.controller.signal });
      updateVariant();
      this.translatePurchase(mount);
      this.translationObserver = new MutationObserver(() => this.translatePurchase(mount));
      this.translationObserver.observe(mount, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['aria-label','placeholder'] });
    }
    translatePurchase(mount) {
      const dictionary = this.messages.form || {};
      const translate = text => {
        if (dictionary[text]) return dictionary[text];
        const packageNote = text.match(/^(\d+) lenses per (pair|box)\. All lenses in a sealed pack have the same prescription\. Different prescriptions require separate packs\.(.*)$/);
        if (packageNote && this.messages.pack_note) return this.messages.pack_note.replace('{count}',packageNote[1]).replace('{unit}',this.messages[packageNote[2]]) + (packageNote[3] ? this.messages.eye_note : '');
        let result = text;
        for (const [source,target] of Object.entries(dictionary)) {
          if (source.endsWith(': ') && result.startsWith(source)) result = target + result.slice(source.length);
          if (source.endsWith(' · ') && result.startsWith(source)) result = target + result.slice(source.length);
        }
        for (const source of ['Left eye','Right eye','Options']) {
          if (dictionary[source] && result.startsWith(source + ': ')) result = dictionary[source] + ': ' + translate(result.slice(source.length + 2));
          for (const prefix of ['Search power for ', 'Prescriptions for ']) if(result === prefix + source) result = (dictionary[prefix] || prefix) + (dictionary[source] || source);
        }
        if(result.endsWith(' · Sold out'))result=result.slice(0,-11)+' · '+this.text('sold_out','Sold out');
        return result;
      };
      const walker = document.createTreeWalker(mount, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) { const node = walker.currentNode; const value = translate(node.nodeValue); if(value !== node.nodeValue)node.nodeValue=value; }
      mount.querySelectorAll('[aria-label],[placeholder]').forEach(element => ['aria-label','placeholder'].forEach(attribute => {const value=element.getAttribute(attribute);if(value){const translated=translate(value);if(translated!==value)element.setAttribute(attribute,translated);}}));
    }
    async share() {
      const status = this.querySelector('[data-pp-share-status]');
      try {
        const url = new URL(window.location.href); url.searchParams.delete('preview_theme_id'); url.searchParams.delete('_fd'); url.searchParams.delete('pb');
        await navigator.clipboard.writeText(url.href); status.textContent=this.text('copied','Link copied');
      } catch { status.textContent=this.text('copy_error','Copy the link from your address bar.'); }
    }
    async loadRelated() {
      const target = this.querySelector('[data-pp-related]'); if(!target)return;
      try {
        const response=await fetch(target.dataset.url,{signal:this.controller.signal});if(!response.ok)return;
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const content=html.querySelector('[data-pp-related]');
        if(content?.querySelector('.pr-card') && this.isConnected){target.innerHTML=content.innerHTML;target.hidden=false;}
      } catch {}
    }
  }
  customElements.define('parana-product',ParanaProductPage);
})();
